import React from "react";
import "./HeroTestimonial.css";
import { useNavigate } from "react-router-dom";
export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="herotest" id="herotest">
      {/* ✅ Overlay for better contrast */}
      <div className="herotest-overlaytest"></div>
      <div className="herotest-contenttest">
        <h1>Customer Testimonials</h1>
        <h2>Why Pakistan Trusts Glamur Paints</h2>
        <button className="ctatest-btntest" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
